import { Text } from '../Typography/Typography';
import { styled } from 'styled-components';

export const Label = styled(Text).attrs({ $semiBold: true })``;
